
import store from '@ps/store';

export default {
  props: {
    nodeId: {
      type: String,
      required: true
    },
    // 如果 targetSceneId 为空，说明没有跳转的场景，不需要展示这个节点的 UI
    targetSceneId: {
      type: String
    }
  },
  inject: ['getGraph', 'getNode'],

  computed: {
    hoverX6Node: function hoverX6Node() {
      return store.state.workspace.storyboard.hoverX6Node || {};
    },
    visible: function visible() {
      if (this.targetSceneId) return true;
      return this.hoverX6Node.id === this.nodeId;
    }
  },

  methods: {
    click: function click() {
      console.log(this.getNode());
    }
  }
};